import * as PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { toast } from 'react-toastify';
import utils from '../lib/utils';
import NewEpikbox from './NewEpikbox';

class NewEpikboxModal extends Component {
  checkIfStateExists = () => {
    const { onConfirm } = this.props;
    const serialNumber = this.state?.formData?.serialNumber;
    if (serialNumber) {
      if (this.state?.formData && Object.keys(this.state?.formData).length) {
        onConfirm(this.state?.formData);
      }
    } else toast.error('Serial number is required');
  };

  onFormDataChange = formData => {
    this.setState({ formData });
  };

  onSerialNumberSelect = e => {
    this.props.onSerialNumberSelect(e);
  };

  render() {
    const {
      isOpen,
      // onConfirm,
      onCancel,
      companies,
      importObj,
      disableCompany,
      getLocationByCompany,
      locations,
      unassignedBoxes,
    } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onCancel} className="create-box-modal">
        <ModalHeader>Assign Epik box</ModalHeader>
        <ModalBody>
          <NewEpikbox
            unassignedBoxes={unassignedBoxes}
            locations={locations}
            getLocationByCompany={getLocationByCompany}
            disableCompany={disableCompany}
            importObj={importObj}
            companies={companies || []}
            onFormDataChange={this.onFormDataChange}
            onSerialNumberSelect={this.onSerialNumberSelect}
          />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="primary" onClick={this.checkIfStateExists}>
            Assign Edge Device
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

NewEpikboxModal.propTypes = {
  isOpen: PropTypes.any,
  onConfirm: PropTypes.any,
  onCancel: PropTypes.any,
  companies: PropTypes.any,
};

export default NewEpikboxModal;
